// @flow
import React, { Fragment } from 'react';
import withClickOutside from 'react-onclickoutside';
import UserMenuItem from 'components/base/UserMenuItem';
import './UserMenu.scss';

type Props = {
  onClick(): void,
  onLogout(): Promise<*>,
  username: string,
  rule: string,
  hasDepositHistory: boolean,
};

const UserMenu = ({ onClick, onLogout, username, rule, hasDepositHistory }: Props) => {
  return (
    <div className="user-menu-wrapper">
      <div className="user-menu-positioner">
        <div className="rotated-square" />
        <div className="user-menu" onClick={onClick}>
          <div className="menu-items">
            {/* <UserMenuItem to={`/@${username}`}>마이페이지</UserMenuItem> */}
            <UserMenuItem to="/orders">주문 목록</UserMenuItem>
            <UserMenuItem to="/wish">찜 목록</UserMenuItem>
            {hasDepositHistory && <UserMenuItem to="/deposit">예치금</UserMenuItem>}
            <div className="separator" />
            <UserMenuItem to="/settings">회원정보수정</UserMenuItem>
            <UserMenuItem onClick={onLogout}>로그아웃</UserMenuItem>
          </div>
        </div>
      </div>
    </div>
  );
};

// $FlowFixMe
export default withClickOutside(UserMenu, {
  handleClickOutside(instance) {
    return instance.props.onClickOutside;
  },
});



// WEBPACK FOOTER //
// ./src/components/base/UserMenu/UserMenu.js